import { OpenAIClient, AzureKeyCredential as OpenAIAzureKeyCredential } from "@azure/openai";

export const ClauseSummaryGenerator = async (): Promise<string | undefined> => {
  const getDocumentText = async (): Promise<string> => {
    return Word.run(async (context) => {
      const body = context.document.body;
      body.load("text");
      await context.sync();
      return body.text;
    });
  };

  const generateKeyValuePairs = async (documentText: string): Promise<Record<string, string>> => {
    const AzureAI: any = JSON.parse(localStorage.getItem("AzureAI") || "{}");
    const endpoint = AzureAI?.Endpoint;
    const azureApiKey = AzureAI?.APIkey;
    const deploymentName = AzureAI?.DeploymentName;

    if (!endpoint || !azureApiKey || !deploymentName) {
      throw new Error("Azure AI configuration is missing.");
    }

    const client = new OpenAIClient(endpoint, new OpenAIAzureKeyCredential(azureApiKey));
    const messages = [
      { role: "system", content: "You are an assistant that extracts key-value pairs from documents." },
      {
        role: "user",
        content: `Extract all key-value pairs from the following text. Do not prefix keys with special characters like "-" or numbers, and ensure all keys have values:\n\n${documentText}`,
      },
    ];
    const response = await client.getChatCompletions(deploymentName, messages, {
      maxTokens: 800,
      temperature: 0,
    });

    const openAIResponse = response.choices[0].message.content.trim();
    try {
      const extractedPairs = JSON.parse(openAIResponse);
      const cleanedPairs = {};
      Object.entries(extractedPairs).forEach(([key, value]) => {
        const cleanedKey: string = key.replace(/^- /, "").trim();
        cleanedPairs[cleanedKey] = value;
      });
      return cleanedPairs;
    } catch {
      console.warn("Response is not valid JSON, processing as plain text.");
      const lines = openAIResponse.split("\n");
      const pairs: Record<string, string> = {};
      lines.forEach((line) => {
        const [key, ...valueParts] = line.split(":");
        if (key && valueParts.length) {
          const cleanedKey: string = key.replace(/^- /, "").trim();
          pairs[cleanedKey] = valueParts.join(":").trim();
        }
      });
      return pairs;
    }
  };

  try {
    const documentText = await getDocumentText();
    const pairs = await generateKeyValuePairs(documentText);
    return JSON.stringify(pairs, null, 2);
  } catch (error) {
    console.error("Error processing Word document:", error);
    return undefined;
  }
};
